module.exports = __webpack_public_path__ + "static/media/menopur-thumb.7441e493.jpg";